
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_COMMITTEEMEETING_LOAD,
    ACTION_COMMITTEEMEETING_LOAD_BY_ID,
    ACTION_COMMITTEEMEETING_LOAD_BY_COMMITTEE_ID,

    ACTION_COMMITTEEMEETING_SAVE,

    ACTION_COMMITTEEMEETING_CREATE,

    ACTION_COMMITTEEMEETING_VALIDATE,

    ICommitteeMeetingLoadAction,
    ICommitteeMeetingLoadByIdAction,
    ICommitteeMeetingLoadByCommitteeIdAction,
    ICommitteeMeetingLoadFailureAction,
    ICommitteeMeetingLoadSuccessAction,

    ICommitteeMeetingSaveAction,
    ICommitteeMeetingSaveSuccessAction,
    ICommitteeMeetingSaveFailureAction,

    ICommitteeMeetingCreateAction,
    ICommitteeMeetingCreateSuccessAction,
    ICommitteeMeetingCreateFailureAction,

    ICommitteeMeetingValidateAction,
    ICommitteeMeetingValidateSuccessAction,
    ICommitteeMeetingValidateFailureAction,

    LoadSuccess,
    LoadFailure,


    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/committeeMeeting";
import { committeeMeetingsApi } from "../services/committeeMeetings";


export const
    getCommitteeMeetingsEpic = (action$): Observable<ICommitteeMeetingLoadSuccessAction | ICommitteeMeetingLoadFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEETING_LOAD)
            .mergeMap((action: ICommitteeMeetingLoadAction) => {
                return committeeMeetingsApi
                    .getCommitteeMeetings(action.committeeId)
                    .map(response =>
                        LoadSuccess(response.committeeMeetings, undefined, [], response.lookups, undefined)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getCommitteeMeetingsByIdEpic = (action$): Observable<ICommitteeMeetingLoadSuccessAction | ICommitteeMeetingLoadFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEETING_LOAD_BY_ID)
            .mergeMap((action: ICommitteeMeetingLoadByIdAction) => {
                return committeeMeetingsApi
                    .getCommitteeMeetingById(action.id)
                    .map(response =>
                        LoadSuccess(response.committeeMeeting, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getCommitteeMeetingsByCommitteeIdEpic = (action$): Observable<ICommitteeMeetingLoadSuccessAction | ICommitteeMeetingLoadFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEETING_LOAD_BY_COMMITTEE_ID)
            .mergeMap((action: ICommitteeMeetingLoadByCommitteeIdAction) => {
                return committeeMeetingsApi
                    .getCommitteeMeetingByCommitteeId(action.committeeId)
                    .map(response =>
                        LoadSuccess(response.committeeMeeting, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setCommitteeMeetingEpic = (action$): Observable<ICommitteeMeetingSaveSuccessAction | ICommitteeMeetingSaveFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEETING_SAVE)
            .mergeMap((action: ICommitteeMeetingSaveAction) => {
                return committeeMeetingsApi
                    .setCommitteeMeeting(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.committeeMeeting, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createCommitteeMeetingEpic = (action$): Observable<ICommitteeMeetingCreateSuccessAction | ICommitteeMeetingCreateFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEETING_CREATE)
            .mergeMap((action: ICommitteeMeetingCreateAction) => {
                return committeeMeetingsApi
                    .createCommitteeMeeting(action.committeeId)
                    .map(response =>
                        CreateSuccess(response.committeeMeeting, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateCommitteeMeetingEpic = (action$): Observable<ICommitteeMeetingValidateSuccessAction | ICommitteeMeetingValidateFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEETING_VALIDATE)
            .mergeMap((action: ICommitteeMeetingValidateAction) => {
                return committeeMeetingsApi
                    .validateCommitteeMeeting(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.committeeMeeting, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }